import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { redirectToOrigin } from "./utils";
import { handleError, toast } from "@/ui/Toast/use-toast";

const queryCache = new QueryCache({
  onError: (error) => {
    if (error.status === 401) {
      const pathname = window.location.pathname;
      const isProgramPage = pathname.match(/^\/programs\/(\d+)$/);
      if (isProgramPage) return;

      redirectToOrigin();
    } else {
      const identityError = error.response?.errors?.[0]?.path?.[0] === "identity";
      const apiKeySuspendedError = error.response?.errors?.[0]?.extensions?.code === "API_KEY_SUSPENDED";
      if (!identityError && !apiKeySuspendedError) {
        handleError(error);
      }
    }
  },
});

const mutationCache = new MutationCache({
  onError: (error) => {
    if (error.status === 401) {
      redirectToOrigin();
    } else {
      handleError(error);
    }
  },
  onSuccess: (data) => {
    if (data?.message) {
      toast({ title: data.message });
    }
  },
});

const queryClient = new QueryClient({
  queryCache,
  mutationCache,
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: process.env.NODE_ENV !== "development" ? 5 * 60 * 1000 : 0,
    },
  },
});

export default queryClient;
